import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../Sidebar';
import Footer from '../Footer';
import Header from '../Header';
import { useAuth } from 'common/context/AuthContext';

//const noFooterPages = ['/login', '/contacts', '/contacts/add_client', '/services', '/contacts/*'];
const footerPages = ['/', '/registration'];

export default function BaseLayout({ isLightTheme, setThemePicked }: { isLightTheme: boolean; setThemePicked: React.Dispatch<React.SetStateAction<boolean>> }) {
  const { token, companyId } = useAuth();
  const location = useLocation();
  //const isNoFooterPage = noFooterPages.includes(location.pathname);
  const isFooterPage = footerPages.includes(location.pathname);
  return (
    <>
      <Header isLightTheme={isLightTheme} setThemePicked={setThemePicked} />
      {token && companyId && <Sidebar isLightTheme={isLightTheme} setThemePicked={setThemePicked} />}
      <Outlet />
      {isFooterPage && <Footer />}
    </>
  );
}

//{ <div className='u-fancy-scrollbar' style={{ /*overflowY: 'auto', height: '100vh', display:'flex', flexDirection:'column'*/ }}>
//  <Outlet />
//</div> }